// Mock data for a-Professional

export const popularCategories = [
  {
    id: 1,
    name: "Personal Trainers",
    image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=300&fit=crop",
    slug: "personal-trainer"
  },
  {
    id: 2,
    name: "House Cleaning",
    image: "https://images.unsplash.com/photo-1647381518264-97ff1835026f?w=400&h=300&fit=crop",
    slug: "house-cleaning"
  },
  {
    id: 3,
    name: "Web Design",
    image: "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=400&h=300&fit=crop",
    slug: "web-design"
  },
  {
    id: 4,
    name: "Gardening",
    image: "https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?w=400&h=300&fit=crop",
    slug: "gardening"
  },
  {
    id: 5,
    name: "Accounting",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop",
    slug: "accounting"
  },
  {
    id: 6,
    name: "Counseling",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=300&fit=crop",
    slug: "counseling"
  }
];

export const serviceCategories = [
  {
    title: "Home and Garden",
    services: [
      { name: "Gardening", image: "https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?w=400&h=300&fit=crop" },
      { name: "House Cleaning", image: "https://images.unsplash.com/photo-1647381518264-97ff1835026f?w=400&h=300&fit=crop" },
      { name: "Painting & Decorating", image: "https://images.unsplash.com/photo-1590650516494-0c8e4a4dd67e?w=400&h=300&fit=crop" }
    ]
  },
  {
    title: "Health & Wellbeing",
    services: [
      { name: "Personal Training", image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=300&fit=crop" },
      { name: "Counseling", image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=300&fit=crop" },
      { name: "Massage Therapy", image: "https://images.unsplash.com/photo-1648542036561-e1d66a5ae2b1?w=400&h=300&fit=crop" }
    ]
  },
  {
    title: "Weddings & Events",
    services: [
      { name: "Wedding Photography", image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400&h=300&fit=crop" },
      { name: "DJ", image: "https://images.pexels.com/photos/6922159/pexels-photo-6922159.jpeg?w=400&h=300&fit=crop" },
      { name: "Magician", image: "https://images.unsplash.com/photo-1515150144380-bca9f1650ed9?w=400&h=300&fit=crop" }
    ]
  },
  {
    title: "Business Services",
    services: [
      { name: "Web Design", image: "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=400&h=300&fit=crop" },
      { name: "Accounting", image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop" },
      { name: "Social Media Marketing", image: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?w=400&h=300&fit=crop" }
    ]
  }
];

export const mostPopularCategories = [
  { name: "Personal Trainers", image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=300&h=300&fit=crop" },
  { name: "Tax Services", image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=300&h=300&fit=crop" },
  { name: "Web Designers", image: "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=300&h=300&fit=crop" },
  { name: "Bookkeepers", image: "https://images.unsplash.com/photo-1547658719-da2b51169166?w=300&h=300&fit=crop" },
  { name: "Cleaners", image: "https://images.unsplash.com/photo-1647381518264-97ff1835026f?w=300&h=300&fit=crop" },
  { name: "Private Security", image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=300&h=300&fit=crop" },
  { name: "DJ Hire", image: "https://images.pexels.com/photos/6922159/pexels-photo-6922159.jpeg?w=300&h=300&fit=crop" },
  { name: "Private Investigator", image: "https://images.unsplash.com/photo-1590650516494-0c8e4a4dd67e?w=300&h=300&fit=crop" },
  { name: "Life Coach", image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=300&h=300&fit=crop" },
  { name: "Gardeners", image: "https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?w=300&h=300&fit=crop" },
  { name: "Photographers", image: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?w=300&h=300&fit=crop" },
  { name: "Dog Trainers", image: "https://images.unsplash.com/photo-1657664043009-c4975cb4eed3?w=300&h=300&fit=crop" },
  { name: "Social Media Marketing", image: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?w=300&h=300&fit=crop" },
  { name: "App Developers", image: "https://images.unsplash.com/photo-1547658719-da2b51169166?w=300&h=300&fit=crop" },
  { name: "SEO Services", image: "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=300&h=300&fit=crop" },
  { name: "Wedding Photographers", image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=300&h=300&fit=crop" },
  { name: "Personal Chef", image: "https://images.unsplash.com/photo-1515150144380-bca9f1650ed9?w=300&h=300&fit=crop" },
  { name: "Business Consultants", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300&h=300&fit=crop" },
  { name: "Massage Therapist", image: "https://images.unsplash.com/photo-1648542036561-e1d66a5ae2b1?w=300&h=300&fit=crop" },
  { name: "Event Photography", image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=300&h=300&fit=crop" }
];

export const testimonials = [
  {
    id: 1,
    name: "Jayne",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop",
    text: "I have used a-Professional twice now for two completely different services and I've had a fantastic experience both times!"
  },
  {
    id: 2,
    name: "Barend",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop",
    text: "One of the most honest experiences I've had on the web, ever! I recommend a-Professional for searching for business professionals."
  },
  {
    id: 3,
    name: "Sunny",
    image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?w=200&h=200&fit=crop",
    text: "Excellent service. They responded much faster than I had anticipated and I was left with a wide range of offers. Brilliant work, a-Professional!"
  },
  {
    id: 4,
    name: "Susan",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200&h=200&fit=crop",
    text: "Both companies that I responded to have been interactive and tended to my concerns and needs, and both were friendly and professional."
  },
  {
    id: 5,
    name: "Aidan",
    image: "https://images.pexels.com/photos/30004315/pexels-photo-30004315.jpeg?w=200&h=200&fit=crop",
    text: "I found using a-Professional amazing. Posted a request and had 5 contacts within 30 minutes. Excellent service."
  },
  {
    id: 6,
    name: "Irene",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop",
    text: "Simply Amazing. Made a booking within minutes!"
  },
  {
    id: 7,
    name: "Jim",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop",
    text: "a-Professional was easy to use and I received sensible quotes. I had a professional visit the next day and he did an excellent job."
  },
  {
    id: 8,
    name: "Peter",
    image: "https://images.pexels.com/photos/30004323/pexels-photo-30004323.jpeg?w=200&h=200&fit=crop",
    text: "Quick and easy service. Got responses instantly and the next day the job had been completed."
  },
  {
    id: 9,
    name: "Michelle",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200&h=200&fit=crop",
    text: "Great service, I'd totally recommend it. Excellent way to find a professional you need."
  },
  {
    id: 10,
    name: "Nathalie",
    image: "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?w=200&h=200&fit=crop",
    text: "I've used a-Professional twice and was really pleased with the quick response I received."
  }
];

export const pressLogos = [
  { name: "TechCrunch", url: "https://d18jakcjgoan9.cloudfront.net/s/img/frontend-v2/directory/press-logos/techcrunch2.png!d=7MZFY" },
  { name: "New York Times", url: "https://d18jakcjgoan9.cloudfront.net/s/img/frontend-v2/directory/press-logos/new-york-times.png!d=6JdSn" },
  { name: "USA Today", url: "https://d18jakcjgoan9.cloudfront.net/s/img/frontend-v2/directory/press-logos/usa-today.png!d=ONBujE" },
  { name: "Cosmopolitan", url: "https://d18jakcjgoan9.cloudfront.net/s/img/frontend-v2/directory/press-logos/cosmopolitan.png!d=bebTX" },
  { name: "Harpers Bazaar", url: "https://d18jakcjgoan9.cloudfront.net/s/img/frontend-v2/directory/press-logos/harpers-bazaar.png!d=o8Yf3" }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Tell us what you need",
    description: "Answer a few quick questions about the service you're looking for. It only takes a couple of minutes."
  },
  {
    step: 2,
    title: "Receive free quotes",
    description: "Get quotes from top-rated professionals in your area. Compare prices, reviews, and portfolios."
  },
  {
    step: 3,
    title: "Hire the best pro",
    description: "Choose the professional that's right for you. Communicate directly and get the job done."
  }
];

export const footerLinks = {
  company: [
    { name: "About", href: "#" },
    { name: "Careers", href: "#" },
    { name: "Press", href: "#" },
    { name: "Blog", href: "#" },
    { name: "Contact", href: "#" }
  ],
  forCustomers: [
    { name: "How it works", href: "#" },
    { name: "Safety", href: "#" },
    { name: "a-Professional Guides", href: "#" },
    { name: "Cost Guides", href: "#" },
    { name: "All Services", href: "#" }
  ],
  forProfessionals: [
    { name: "Sign Up", href: "#" },
    { name: "How it works", href: "#" },
    { name: "Pricing", href: "#" },
    { name: "Success Stories", href: "#" },
    { name: "Help Centre", href: "#" }
  ],
  legal: [
    { name: "Terms of Use", href: "/terms" },
    { name: "Privacy Policy", href: "/privacy" },
    { name: "Cookie Policy", href: "#" },
    { name: "Accessibility", href: "#" }
  ]
};

export const navLinks = [
  { name: "How it works", href: "#how-it-works" },
  { name: "Join as a Pro", href: "#join-pro" },
  { name: "Services", href: "#services" }
];
